import logo from "../../assets/images/logo.svg";
import React from "react";
import { Logo } from "./Header.style";
import AnimatedTitle from "./AnimatedTitle";

const Header = () => {
  return (
    <>
      <Logo src={logo} />
      <header>
        <AnimatedTitle />
      </header>
    </>
  );
};

export default Header;
